import React from 'react';
import type NextGenRoadmapType from '@atlassian/jira-spa-apps-roadmap/src/view/next-gen/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyNextGenRoadmap = lazyForPaint<typeof NextGenRoadmapType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-roadmap", jiraSpaEntry: "async-roadmap" */ '@atlassian/jira-spa-apps-roadmap/src/view/next-gen'
		),
	),
);

const AsyncNextGenRoadmap = ({ match }: RouteContext): React.JSX.Element => (
	<LazyPage
		Page={LazyNextGenRoadmap}
		pageId={`next-gen-roadmap-${match.params.boardId || ''}`}
		shouldShowSpinner={false}
	/>
);

export default AsyncNextGenRoadmap;
